import { getFirstObjectValue, getObjectValue } from "./objectPath";
import { runScript2 } from "./script";

export type MapPropTypes =
    "simple" |
    "list" |
    "customValue" |
    "customListValue"
;

export interface MapProp {
    src?: string,
    srcType?: MapPropTypes, // if not provided assume simple

    dest?: string, // if not provided assume exactly the same as "name"
    destType?: MapPropTypes, // if not provided assume simple

    customValue?: string,

    // map to use for children (applies to lists)
    map?: Map,

}

export interface Map {
    props: MapProp[],
    criteria?: string, // script
}


export function transform(
	map: Map,
	srcObj: any,
	destObj: any,
) {

	if (map.criteria) {
		const ok = runScript2(map.criteria, srcObj);
		if (!ok) return;
	}

	for(let p of map.props) {
        let propFrom = p.src!;
		let exact = false;
		if (propFrom.startsWith(".")) {
			propFrom = propFrom.substring(1);
			exact = true;
		}
        const propTo = p.dest ? p.dest : propFrom;
        const srcType = p.srcType ? p.srcType : "simple";
        const destType = p.destType ? p.destType : srcType;

		if (srcType && propFrom) {
			const v = exact ? getObjectValue(srcObj, propFrom) : getFirstObjectValue(srcObj, propFrom);

			if (srcType === "simple") {
				destObj[propTo] = v;
	
			} else if (srcType === "list") {
				if (Array.isArray(v)) {
					// do the list items need to be mapped? 
					if (p.map) {
						// yes, map each list item
						const destList: any[] = [];
						destObj[propTo] = destList;
						for(let item of v) {
							const destItem = {} as any;
							transform(p.map, item, destItem);
							destList.push(destItem);
						}

					} else {
						// no map, so just copy exactly
						destObj[propTo] = v;

					}
				}
	
			}
	
		}




	}


}

